import { UserStatus } from '../types';
import { UserStatusValue } from '../utils';

export class UserStatusOption {
	value!: UserStatus;
	text!: string;
	icon!: string;
	appearance!: string;

	constructor(payload: UserStatusValue) {
		const { value, text, icon, appearance } = payload;
		this.value = value;
		this.text = text;
		this.icon = icon;
		this.appearance = appearance;
	}

	protected toString() {
		return this.text;
	}

	public valueOf(): UserStatus {
		return this.value;
	}
}
